import React, { useEffect, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import {
	PaymentElement,
	CardElement,
	CardNumberElement,
	CardExpiryElement,
	PaymentRequestButtonElement,
	useStripe,
	useElements,
} from "@stripe/react-stripe-js";
import { StripeError } from "@stripe/stripe-js";
import { connect } from "react-redux";
import RedeemIcon from "@material-ui/icons/Redeem";
import CheckCircleRounded from "@material-ui/icons/CheckCircleRounded";
import axios from "axios";
import clsx from "clsx";
import { v4 as uuidv4 } from "uuid";
import { THEME_COLORS } from "../../theme";
import NotificationsService from "../../laco-common/services/notifications";
import { UIButtonWithLoadingProgress, UIStyledTooltip } from "../ui/UIComponents";
import { IAuthContext } from "../../laco-common/base/auth";
import AuthContext from "../../laco-common/auth/AuthContext";
// import CartService from "../../services/CartService";
import { mapStripeStateToProps } from "../../redux/reducers/stripe";
import { IStripeStoreProps, mapStripeDispatchToProps } from "../../redux/actions/stripe";
import { DynamicForm } from "../../forms/DynamicForm";
import { DynamicFormValidation } from "../../laco-common/base/form-validation/dynamic";
import { isLocalhost } from "../../serviceWorker";
import { TextSelectInput } from "../../forms/InputComponents";
import { OrderDetails, OrderItem } from "../../laco-common/base/models/order";
import { WidgetProps } from "../widgets";
import { UIActions } from "../../components/peer-support/Actions";
import { LOCAL_STORAGE_KEYS } from "../../models/localStorage";
import "./PaymentForm.scss";

type StripePaymentFormProps = IStripeStoreProps &
	WidgetProps & {
		// onSubmit: ()=> {}
	};

const CARD_OPTIONS = {
	// iconStyle: "solid",
	style: {
		base: {
			iconColor: THEME_COLORS.primary,
			color: THEME_COLORS.gray,
			fontWeight: 500,
			fontFamily: "Montserrat, sans-serif",
			fontSize: "16px",
			fontSmoothing: "antialiased",
			":-webkit-autofill": { color: "black" },
			"::placeholder": { color: "gray" },
		},
		invalid: {
			iconColor: "#f44336",
			color: "#f44336",
		},
	},
};

const PaymentFormC: React.FC<StripePaymentFormProps> = (props: StripePaymentFormProps) => {
	const authContext: IAuthContext = useContext(AuthContext);
	const [processing, setProcessing] = useState<boolean>(false);
	const [processingPromoCode, setProcessingPromoCode] = useState<boolean>(false);
	const [form, setForm] = useState<DynamicFormValidation>(null);
	const [email, setEmail] = useState<string>(
		props.orderEmail || authContext.userPayload?.email || authContext.getUserIdentifier()
	);
	const [total, setTotal] = useState<number>(0);
	const [itemName, setItemName] = useState<string>("");
	const [description, setDescription] = useState<string>("");
	const [comments, setComments] = useState<string>("");
	const stripe = useStripe();
	const elements = useElements();

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		props.clearCompletedOrder();
		setForm(
			new DynamicFormValidation({
				email: {
					fieldType: "email",
					// label: "Email",
					placeholder: "Please enter your email address for order confirmation",
					value: props.orderEmail || authContext.userPayload?.email || authContext.getUserIdentifier(),
					order: 0,
				},
			})
		);
		console.log("props.cartItems:", props.cartItems);
		console.log("props.orderEmail:", props.orderEmail);
		const { total, name, description } = await props.getCartSummary();
		setTotal(total);
		setItemName(name || "");
		setDescription(description || "");

		// const intent = await stripe.retrievePaymentIntent(
		// 	"sk_test_51KTj5XBoFj9E3RFYm5zM05wEcwfAuVRMebNYs8bKBVqJj1svlNoWdlLsAU6N6mgPD6oFIH3goCwTyPXounjdU8Dr008Vyn1szR"
		// );
		// debugger;
		// const customer = await stripe.customers.create({
		// 	email: data.email, // Pass email (Optional)
		// 	name: data.name, // Pass name (Optional)
		//   });
		// // Store customer.id to your database for future reference
	};

	const setUserEmail = (email: string) => {
		setEmail(email);
		authContext.setAnonymousUserEmail(email);
	};

	const createOrder = (id: string = uuidv4()): OrderDetails => {
		let description: string = `Order No: ${id} \n\r`;
		props.cartItems.forEach((item: OrderItem, index: number) => {
			description += `${index > 0 ? "\n\r" : ""}${getItemDisplay(item)}`;
		});
		return {
			id,
			amount: Math.round(total * 100), // amount in cents
			description,
			receipt_email: email,
			comments,
		};
	};

	const handleSubmit = async (e) => {
		e?.preventDefault();
		// create test order
		if (isLocalhost) {
			const params: OrderDetails = {
				...createOrder(),
				testOrder: true,
			};
			return await onSuccess(params);
		}
		const { error, paymentMethod } = await stripe.createPaymentMethod({
			type: "card",
			card: elements.getElement(CardElement),
			// customerId // TODO
		});

		// 	const paymentResult = await stripe.confirmCardPayment(clientSecret, {
		// 		payment_method: {
		// 		  card: elements.getElement(CardElement),
		// 		  billing_details: {
		// 			name: "Faruq Yusuff",
		// 		  },
		// 		},
		//   });

		if (!error) {
			try {
				const { id } = paymentMethod;
				const params: OrderDetails = createOrder(id);

				const response = await axios.post(
					"https://us-central1-la-county-fire-dep.cloudfunctions.net/makeStripePayment",
					params
				);

				console.log("makeStripePayment response:", response);
				if (response.data?.success) {
					console.log("successfull payment. id:", id);
					return await onSuccess(params);
				} else {
					onError(response.data?.error?.code, response.data.error?.code || "Invalid card information");
				}
			} catch (err) {
				onError(err, "Server error caught");
			}
		} else {
			onError(error, "Error creating payment method");
		}
	};

	const onError = (e: Error | StripeError, errReason) => {
		console.error("Payment has error:", errReason, e);
		NotificationsService.error(`Error completing payment: ${e?.message || errReason}`, undefined, {
			autoHideDuration: null,
		});
	};

	const onSuccess = async (details: OrderDetails) => {
		console.log("Successful payment");
		return await props.onCompletePayment(details, email, authContext.uid).then(() => {
			// props.loadOrders(email, authContext.uid);
			props.clearCart();
			NotificationsService.success("Thank you for your order!");
			// setOrderPlaced(details);
			// TODO: success page
			// props.history.push("/user/profile");
		});
	};

	const onDeleteItem = (item: OrderItem): Promise<any> => {
		props.deleteFromCart(item);
		return Promise.resolve();
	};

	const getItemDisplay = (item: OrderItem) => {
		const amountStr: string = `X ${item.amount}`;
		return `${item.name} ${amountStr}`;
	};

	const orderPlaced = props.orderPlaced;
	return (
		<div
			className={clsx(
				!props.isNested && "container",
				"payment-form-container d-flex flex-column",
				!props.page?.noPadding && "section-padding"
			)}
		>
			{!!orderPlaced ? (
				<div className="order-success d-flex flex-column align-items-center p-3">
					<h2>Order Placed</h2>
					<CheckCircleRounded />
					<div className="mt-3">
						<h3>
							<strong>Thank you! Your order has been successfully placed.</strong>
						</h3>
					</div>
					<div className="mb-4">
						{orderPlaced.items.map((item: OrderItem) => (
							<div>
								<strong>{getItemDisplay(item)}</strong>
							</div>
						))}
					</div>
					<div>Order #{orderPlaced.id}</div>
					<div className="my-3 text-sm">Email confirmation has been sent to {orderPlaced.receipt_email}</div>
				</div>
			) : (
				<>
					{!authContext.isAuthenticated && !props.orderEmail && (
						<div className="row">
							<div className="col-3 col-sm-12 mb-1">
								<NavLink
									to="/login"
									onClick={() => localStorage.setItem(LOCAL_STORAGE_KEYS.LOGIN_REDIRECT, "/payment")}
								>
									Login{" "}
								</NavLink>
								or enter your email:
							</div>
							<div className="col-9 col-sm-12">
								<DynamicForm
									form={form}
									noFooter={true}
									onChange={(key: string, f: DynamicFormValidation) => {
										if (f.isValid) {
											setUserEmail(f.values[key]);
										}
									}}
								/>
							</div>
						</div>
					)}

					<form>
						{/* <h2>Items</h2> */}
						<ul className="cart-items my-5">
							{(props.cartItems || []).map((item: OrderItem, index: number) => (
								<li key={index} className="d-flex justify-content-between">
									<div>
										<div className="item-name">{item.name}</div>
										<div className="item-description text-gray">{item.description}</div>
									</div>
									<div className="d-flex flex-column-reverse flex-md-row align-items-end">
										<div className="amount">X {item.amount}</div>
										<div style={{ marginLeft: "15px" }}>${item.price.toFixed(2)}</div>
										<div className="mb-2-mobile">
											<UIActions
												data={item}
												itemName={item.name}
												onDelete={(item: OrderItem) => {
													return onDeleteItem(item);
												}}
												skipRoles={true}
											/>
										</div>
									</div>
								</li>
							))}
						</ul>

						<div className="cart-total mb-3 d-flex flex-column justify-content-end align-items-end">
							<div className="total">
								Total <span className="pl-2 font-weight-bold">${total.toFixed(2)}</span>
							</div>
						</div>

						<DynamicForm
							form={
								new DynamicFormValidation({
									comments: {
										fieldType: "textarea",
										label: "Order Comments",
										placeholder: "Leave us a note about your order",
										value: comments,
										order: 0,
									},
								})
							}
							noFooter={true}
							onChange={(key: string, f: DynamicFormValidation) => {
								setComments(f.values[key]);
							}}
						/>

						<h2 className="mt-5">Payment</h2>
						<fieldset className="FormGroup">
							<div className="FormRow">
								<CardElement
									options={{
										...CARD_OPTIONS,
										disabled: (!authContext.isAuthenticated && !email) || !total,
									}}
								/>
							</div>
						</fieldset>
						{/* <PaymentElement /> */}

						<div className="d-flex justify-content-end mt-3">
							<UIButtonWithLoadingProgress
								actionName="Processing..."
								type="button"
								onClick={(e) => {
									setProcessing(true);
									return handleSubmit(e).then(() => {
										setProcessing(false);
									});
								}}
								disabled={processing || (!authContext.isAuthenticated && !email)}
								// disabledTitle={ // dana
								// 	!authContext.isAuthenticated && !email ? "Enter valid email or login" : undefined
								// }
								className="btn btn-primary w-100-sm mt-3"
							>
								Complete Order
							</UIButtonWithLoadingProgress>
						</div>
					</form>
				</>
			)}
		</div>
	);
};

export const PaymentForm = connect(mapStripeStateToProps, mapStripeDispatchToProps)(PaymentFormC);
